import { render, staticRenderFns } from "./sub-image-on.vue?vue&type=template&id=cff981e6&scoped=true&"
import script from "./sub-image-on.vue?vue&type=script&lang=js&"
export * from "./sub-image-on.vue?vue&type=script&lang=js&"
import style0 from "./sub-image-on.vue?vue&type=style&index=0&id=cff981e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff981e6",
  null
  
)

export default component.exports